<template>
    <div class="collar-status-icon" :id="id" v-if="tooltip" v-b-tooltip.noninteractive.hover.bottom :title="name" :class="[code,{'small':small}]">
        <span class="material-icons-round d-block">military_tech</span>
    </div>
    <div v-else class="collar-status-icon" :id="id" :class="[code,{'small':small}]">
        <span v-if="code == 'none'">-</span>
        <span v-else class="material-icons-round d-block">military_tech</span>
    </div>
</template>
<script>
import { VBTooltip } from 'bootstrap-vue'

export default {
    props:{
        id:{
            type:[String,null],
            default:null
        },
        code:{
            type:String,
            default:'none'
        },
        name:{
            type:String,
            default:''
        },
        tooltip:{
            type:Boolean,
            default:false
        },
        small:{
            type:Boolean,
            default:false
        }
    },
    directives:{
        'b-tooltip':VBTooltip
    }
}
</script>

<style>
.collar-status-icon{
    height: 3rem;
    width: 3rem;
    font-size: 2.25rem;
    border-radius: 100%;
    display:flex;
    align-items: center;
    justify-content: center;
}
.collar-status-icon.small{
    height: 1.875rem;
    width: 1.875rem;
    min-width:  1.875rem;
    font-size: 1.25rem;
}
.collar-status-icon.White{
    background-color: black;
    color: white;
}
.collar-status-icon.Blue{
    background-color: rgba(31, 70, 144,0.25);
    color: var(--primary);
}
.collar-status-icon.Driver{
    background-color: black;
    color: var(--success);
}
.collar-status-icon > span{
    font-size: inherit;
}
.collar-status-icon.none{
    background-color: var(--light)
}
.dark-layout .collar-status-icon.none{
    background-color: #3b4253 !important
}
</style>